import * as Yup from 'yup';

export interface ForgotPasswordFormFields {
  email: string;
}

export const defaultValues: ForgotPasswordFormFields = Object.freeze({
  email: ''
});

export const forgotPasswordValidationSchema = (t: any) => {
  const shapeObject = {
    email: Yup.string()
      .required(t('general.form.validation.genericRequired', { value: t('general.form.email') }))
      .email(t('general.form.validation.email'))
      .nullable()
  } as Record<keyof ForgotPasswordFormFields, any>;
  return Yup.object().shape(shapeObject);
};
